/**
 * 脚本退出机制代码
 *
 * 必须在 javaLib 之前加载，因为 openApp.java.js 等文件会使用 addScriptExitListener
 */
export const scriptExitMechanismCode = `// ==================== 脚本退出机制 ====================

let isScriptRunnable = true;
let scriptExitListeners = [];

function addScriptExitListener(f){
    console.log('[addScriptExitListener] 添加监听器');
    removeScriptExitListener(f);
    scriptExitListeners.push(f);
    console.log('[addScriptExitListener] 监听器数量:', scriptExitListeners.length);
}

function removeScriptExitListener(f){
    console.log('[removeScriptExitListener] 移除监听器');
    let index = scriptExitListeners.indexOf(f);
    if(index == -1){
        console.log('[removeScriptExitListener] 监听器不存在');
        return;
    }
    scriptExitListeners.splice(index, 1);
    console.log('[removeScriptExitListener] 监听器已移除, 剩余数量:', scriptExitListeners.length);
}

function onJavaCallTerminate(){
    console.log('[onJavaCallTerminate] Java 调用终止');
    callScriptExit();
    return true;
}

function callJavaExit(){
    console.log('[callJavaExit] 调用 Java 退出');

    // 检查javaRunner是否存在
    const javaRunnerExists = typeof javaRunner !== 'undefined';
    console.log('[callJavaExit] javaRunner是否存在:', javaRunnerExists);

    if (!javaRunnerExists) {
        console.log('[callJavaExit] javaRunner未注入,无法通知Java退出');
        return;
    }

    // 检查onJsCallStoped方法是否存在
    const methodExists = typeof javaRunner.onJsCallStoped === 'function';
    console.log('[callJavaExit] onJsCallStoped方法是否存在:', methodExists);

    if (!methodExists) {
        console.log('[callJavaExit] javaRunner.onJsCallStoped方法不存在');
        return;
    }

    // 调用Java端的正常退出方法
    console.log('[callJavaExit] 调用javaRunner.onJsCallStoped');
    try {
        javaRunner.onJsCallStoped();
        console.log('[callJavaExit] 调用成功');
    } catch (e) {
        console.log('[callJavaExit] 调用异常');
        console.log('[callJavaExit] 异常消息:', e.message);
        console.log('[callJavaExit] 异常堆栈:', e.stack);
    }
}

function jsCallComplete(){
    console.log('[jsCallComplete] 脚本完成');
    callScriptExit();
    callJavaExit();
}

function jsCallFailed(){
    console.log('[jsCallFailed] 脚本失败');
    callScriptExit();
    callJavaExit();
}

function callScriptExit(){
    console.log('[callScriptExit] 调用脚本退出');
    isScriptRunnable = false;
    console.log('[callScriptExit] 退出监听器数量:', scriptExitListeners.length);

    scriptExitListeners.forEach((f)=>{
        console.log('[callScriptExit] 执行退出监听器');
        f();
    });

    console.log('[callScriptExit] 所有退出监听器已执行');
}

/**
 * 请求Project强制退出
 * 调用Java端的强制退出方法
 * @param {string} reason 退出原因
 * @returns {boolean} 是否成功调用
 */
function requestProjectForceExit(reason) {
    console.log('[requestProjectForceExit] 请求强制退出');
    console.log('[requestProjectForceExit] reason:', reason);

    const javaRunnerExists = typeof javaRunner !== 'undefined';
    console.log('[requestProjectForceExit] javaRunner是否存在:', javaRunnerExists);

    if (!javaRunnerExists) {
        console.log('[requestProjectForceExit] javaRunner未注入,无法请求退出');
        return false;
    }

    const methodExists = typeof javaRunner.onJsCallForceExit === 'function';
    console.log('[requestProjectForceExit] onJsCallForceExit方法是否存在:', methodExists);

    if (!methodExists) {
        console.log('[requestProjectForceExit] javaRunner.onJsCallForceExit方法不存在');
        return false;
    }

    console.log('[requestProjectForceExit] 调用javaRunner.onJsCallForceExit');
    try {
        javaRunner.onJsCallForceExit();
        console.log('[requestProjectForceExit] 调用成功');
        return true;
    } catch (e) {
        console.log('[requestProjectForceExit] 调用异常');
        console.log('[requestProjectForceExit] 异常消息:', e.message);
        console.log('[requestProjectForceExit] 异常堆栈:', e.stack);
        return false;
    }
}
`

/**
 * projectRunner2.js 主代码
 *
 * 这是将 IProjectData 转换为可执行 Rhino JavaScript 的核心脚本
 *
 * 注意：脚本退出机制已移到 scriptExitMechanismCode 中
 */
export const projectRunner2Text = `
// ==================== 辅助函数 ====================

/**
 * 将对象转为 JSON 字符串，用于详细日志输出
 * 使用 Java 的 Gson 或 JavaScript 的 JSON.stringify
 */
function toJsonString(obj) {
    try {
        return com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(obj);
    } catch (e) {
        try {
            return JSON.stringify(obj);
        } catch (e2) {
            return String(obj);
        }
    }
}

// ==================== 从 javaLib 提取依赖函数 ====================

console.log("[projectRunner2] 从 javaLib 提取 createEventDispatcher");
var createEventDispatcher = javaLib['fanfanlo/javajs/v1/event/createEventDispatcher'].createEventDispatcher;
console.log("[projectRunner2] createEventDispatcher 提取结果:", typeof createEventDispatcher);

console.log("[projectRunner2] 从 javaLib 提取 createGetterSetter");
var createGetterSetter = javaLib['fanfanlo/javajs/v1/utils/createGetterSetter'].createGetterSetter;
console.log("[projectRunner2] createGetterSetter 提取结果:", typeof createGetterSetter);

// ==================== 常量定义 ====================

let baseInternalIndex = 0;

let eventTypeComplete = "eventTypeComplete";
let eventTypeFailed = "eventTypeFailed";
let eventTypeSuccess = "eventTypeSuccess";
let eventTypeError = "eventTypeError";
let eventTypeExit = "eventTypeExit";
let eventTypeTriggerConditionsOn = "eventTypeTriggerConditionsOn";
let eventTypeTriggerConditionsOff = "eventTypeTriggerConditionsOff";

let baseType = {
    trigger: "trigger",
    action: "action",
    project: "project",
    triggerActionGroup: "triggerActionGroup",
    triggerAction: "triggerAction",
    triggerGroup: "triggerGroup",
    actionGroup: "actionGroup"
};

let projectInitData;

// ==================== 工具函数 ====================

function callProjectMemberListExit(list){
    console.log("[callProjectMemberListExit] 退出列表", "长度:", list.length);
    for (var i = 0; i < list.length; i++) {
        try{
            console.log("[callProjectMemberListExit] 退出项", i, list[i].id);
            list[i].exit();
        }catch(e){
            console.log("[callProjectMemberListExit] 错误", e.message);
        }
    }
}

function setChildProjectTaskAction(that, child){
    console.log("[setChildProjectTaskAction] 设置引用", "parent:", that.baseType, "child:", child.baseType);

    var project = that.baseType == baseType.project ? that : that.project;
    child.project = project;

    console.log("[setChildProjectTaskAction] child.project 已设置", child.id);
}

// ==================== createCommonBase ====================

function createCommonBase(that, name, type, baseTypeValue){
    console.log("[createCommonBase] 创建", "name:", name, "type:", type, "baseType:", baseTypeValue);

    baseInternalIndex++;
    that = that || {};

    var dispatcher = createEventDispatcher();
    var loggerName = name || baseTypeValue || type;
    var logger = console.subLogger(loggerName + ":" + baseInternalIndex);

    logger.log("初始化 name=" + name + ", baseType=" + baseTypeValue);

    createGetterSetter(that, "logger", logger, {readonly:true});
    createGetterSetter(that, "dispatcher", dispatcher, {readonly:true}, undefined, undefined, undefined);
    createGetterSetter(that, "baseType", baseTypeValue, {readonly:true}, that.dispatcher);
    createGetterSetter(that, "isRunnable", undefined, {readonly:true}, undefined, undefined, (value, that, key)=>{
        var bl = isScriptRunnable &&
                 (that.project ? that.project.isRunnable : true) &&
                 (that.owner ? that.owner.isRunnable : true) &&
                 (!that.isExited && !that.isTerminated);
        return bl;
    });
    createGetterSetter(that, "baseMsg", undefined, {readonly:true}, undefined, undefined, (value, that, key)=>{
        return "base msg|baseInternalIndex=" + that.baseInternalIndex +
               ", baseType=" + that.baseType + ", name=" + that.name + ", type=" + that.type;
    });

    createGetterSetter(that, "data", undefined, {}, dispatcher);
    createGetterSetter(that, "buildData", undefined, {}, dispatcher);
    createGetterSetter(that, "owner", undefined, {}, dispatcher);
    createGetterSetter(that, "isRunning", false, {}, dispatcher);
    createGetterSetter(that, "isExited", false, {}, dispatcher);
    createGetterSetter(that, "isTerminated", false, {}, dispatcher);
    createGetterSetter(that, "name", name || type, {}, dispatcher);
    createGetterSetter(that, "type", type, {}, dispatcher);
    createGetterSetter(that, "baseInternalIndex", baseInternalIndex, {readonly:true}, dispatcher);
    createGetterSetter(that, "project", undefined, {}, dispatcher);

    function run(owner){
        this.owner = owner;
        this.logger.log("run 开始", "isRunnable:", this.isRunnable);
        if(!this.isRunnable){
            this.logger.log("run 不可执行,跳过");
            return;
        }
        this.isRunning = true;
        this.logger.log("run 调用 onRun");
        this.onRun();
    }

    function onRun(){
        this.logger.log("onRun 空实现");
    }

    function exit(){
        this.logger.log("exit 开始", this.type);
        if(this.isExited)return;
        this.isExited = true;
        this.dispatcher.dispatch(eventTypeExit);
        this.dispatcher.removeAllListeners();
        this.onExit();
    }

    function onExit(){
        this.logger.log("onExit 空实现");
    }

    that.run = run.bind(that);
    that.onRun = onRun.bind(that);
    that.exit = exit.bind(that);
    that.onExit = onExit.bind(that);

    return that;
}

// ==================== attachAbstractAct ====================

function attachAbstractAct(that){
    console.log("[attachAbstractAct] 添加成功/失败/完成机制", that.name);

    var dispatcher = that.dispatcher;

    createGetterSetter(that, "isSuccess", false, {}, dispatcher);
    createGetterSetter(that, "isFailed", false, {}, dispatcher);
    createGetterSetter(that, "isCompleted", false, {}, dispatcher);

    function dispatchSuccess(){
        this.logger.log("dispatchSuccess 开始", "isSuccess:", this.isSuccess);
        if(this.isSuccess)return;
        this.isSuccess = true;
        this.isFailed = false;
        this.logger.log("dispatchSuccess 分发事件");
        this.dispatcher.dispatchData(eventTypeSuccess, {target:this});
        this.dispatchComplete();
    }

    function dispatchComplete(){
        this.logger.log("dispatchComplete 开始", "isRunning:", this.isRunning);
        if(!this.isRunning)return;
        this.logger.log("dispatchComplete 分发事件");
        this.isRunning = false;
        this.isCompleted = true;
        this.dispatcher.dispatchData(eventTypeComplete, {target:this});
    }

    function dispatchFailed(data){
        this.logger.log("dispatchFailed 开始", "isFailed:", this.isFailed);
        if(this.isFailed)return;
        this.isSuccess = false;
        this.isFailed = true;
        this.logger.log("dispatchFailed 分发事件");
        this.dispatcher.dispatchData(eventTypeFailed, {target:this, data:data});
        this.dispatchComplete();
    }

    var superRun = that.run;
    function run(owner){
        this.logger.log("run 重置状态");
        this.isSuccess = false;
        this.isFailed = false;
        superRun.call(this, owner);
    }

    that.dispatchSuccess = dispatchSuccess.bind(that);
    that.dispatchComplete = dispatchComplete.bind(that);
    that.dispatchFailed = dispatchFailed.bind(that);
    that.run = run.bind(that);

    return that;
}

// ==================== attachAbstractParent ====================

function attachAbstractParent(that){
    console.log("[attachAbstractParent] 添加children管理", that.name);

    createGetterSetter(that, "children", [], {}, that.dispatcher);

    var superOnExit = that.onExit;
    function onExit(){
        this.logger.log("onExit 退出所有children");
        callProjectMemberListExit(this.children);
        superOnExit.call(this);
    }

    that.onExit = onExit.bind(that);
}

// ==================== attachQueueGroup ====================

function attachQueueGroup(that){
    console.log("[attachQueueGroup] 添加队列执行功能", that.name);

    attachAbstractAct(that);
    attachAbstractParent(that);

    createGetterSetter(that, "childIndex", 0, {}, that.dispatcher);

    function onChildSuccess(event){
        this.logger.log("onChildSuccess 子项成功", event.target.name);
        this.checkDoNextOrComplete();
    }

    function checkDoNextOrComplete(){
        if(!this.isRunnable){
            this.logger.log("checkDoNextOrComplete 不可运行");
            return;
        }

        this.logger.log("checkDoNextOrComplete", "childIndex:", this.childIndex, "总数:", this.children.length);

        if(this.childIndex < this.children.length - 1){
            this.childIndex++;
            this.checkRunIndex();
        }else{
            this.logger.log("checkDoNextOrComplete 所有子项完成");
            this.dispatchSuccess();
        }
    }

    function onChildFailed(event){
        this.logger.log("onChildFailed 子项失败", event.target.name);
        this.dispatchFailed({target:this, data:event.data});
    }

    function onChildComplete(event){
        this.logger.log("onChildComplete 子项完成", event.target.name);
    }

    var superOnRun = that.onRun;
    function onRun(){
        this.logger.log("onRun 队列执行开始");
        this.checkRunIndex();
        superOnRun.call(this);
    }

    function checkRunIndex(){
        var child = this.children[this.childIndex];

        if(child == undefined){
            this.logger.log("checkRunIndex child未定义", this.childIndex);
            this.dispatchFailed({err:new Error("child is undefined"), index:this.childIndex});
            return;
        }

        this.logger.log("checkRunIndex 执行child", this.childIndex, child.name);

        child.dispatcher.listenData(eventTypeComplete, this.onChildComplete);
        child.dispatcher.listenData(eventTypeFailed, this.onChildFailed);
        child.dispatcher.listenData(eventTypeSuccess, this.onChildSuccess);

        setChildProjectTaskAction(this, child);
        child.run(this);
    }

    that.onChildSuccess = onChildSuccess.bind(that);
    that.checkDoNextOrComplete = checkDoNextOrComplete.bind(that);
    that.onChildFailed = onChildFailed.bind(that);
    that.onChildComplete = onChildComplete.bind(that);
    that.onRun = onRun.bind(that);
    that.checkRunIndex = checkRunIndex.bind(that);

    return that;
}

// ==================== attachConcurrentGroup ====================

function attachConcurrentGroup(that){
    console.log("[attachConcurrentGroup] 添加并发执行功能", that.name);

    attachAbstractAct(that);
    attachAbstractParent(that);

    createGetterSetter(that, "completeConditions", [], {}, that.dispatcher);

    function checkIsSuccess(){
        this.logger.log("checkIsSuccess 检查", "completeConditions长度:", this.completeConditions.length);
        this.logger.log("checkIsSuccess children长度:", this.children.length);

        if(this.completeConditions.length == 0){
            this.logger.log("checkIsSuccess 无条件,默认成功");
            return true;
        }

        for (var i = 0; i < this.completeConditions.length; i++) {
            var list = this.completeConditions[i];
            var hasFailed = false;

            this.logger.log("checkIsSuccess 检查条件", i, "list长度:", list.length);

            for (var j = 0; j < list.length; j++) {
                var required = list[j];  // 布尔值：是否要求该位置的 child 成功
                this.logger.log("checkIsSuccess 位置", j, "required:", required);

                if (required) {
                    // 只有当 required 为 true 时才检查对应位置的 child
                    var child = this.children[j];  // 用 j 作为索引，而不是 list[j]

                    if (!child) {
                        this.logger.log("checkIsSuccess child未定义", "index:", j);
                        hasFailed = true;
                        break;
                    }

                    if (child.isSuccess == false) {
                        this.logger.log("checkIsSuccess child未成功", j, "child.name:", child.name);
                        hasFailed = true;
                        break;
                    }
                }
            }

            if(!hasFailed){
                this.logger.log("checkIsSuccess 满足条件", i);
                return true;
            }
        }

        this.logger.log("checkIsSuccess 不满足任何条件");
        return false;
    }

    function checkSuccess(){
        if(this.isSuccess){
            this.logger.log("checkSuccess 已经成功");
            return;
        }

        if(!this.checkIsSuccess()){
            this.logger.log("checkSuccess 条件不满足");
            return;
        }

        this.logger.log("checkSuccess 分发成功");
        this.dispatchSuccess();
    }

    function checkComplete(){
        if(this.isSuccess){
            this.logger.log("checkComplete 已经成功");
            return;
        }

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if(!child.isExited){
                this.logger.log("checkComplete 还有child未退出", i);
                return;
            }
        }

        this.logger.log("checkComplete 所有child已退出");
        this.dispatchComplete();
    }

    function onChildSuccess(event){
        this.logger.log("onChildSuccess 子项成功", event.target.name);
        this.checkSuccess();
    }

    function onChildFailed(event){
        this.logger.log("onChildFailed 子项失败", event.target.name);
        this.checkSuccess();
    }

    function onChildComplete(event){
        this.logger.log("onChildComplete 子项完成", event.target.name);
        this.checkComplete();
    }

    function onRun(){
        this.logger.log("onRun 并发执行", "children数量:", this.children.length);

        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];

            this.logger.log("onRun 启动child", i, child.name);

            child.dispatcher.listenData(eventTypeComplete, this.onChildComplete);
            child.dispatcher.listenData(eventTypeFailed, this.onChildFailed);
            child.dispatcher.listenData(eventTypeSuccess, this.onChildSuccess);

            setChildProjectTaskAction(this, child);
            child.run(this);
        }
    }

    var superOnExit = that.onExit;
    function onExit(){
        this.logger.log("onExit 退出所有children");
        callProjectMemberListExit(this.children);
        superOnExit.call(this);
    }

    that.checkIsSuccess = checkIsSuccess.bind(that);
    that.onChildSuccess = onChildSuccess.bind(that);
    that.onChildFailed = onChildFailed.bind(that);
    that.onChildComplete = onChildComplete.bind(that);
    that.checkSuccess = checkSuccess.bind(that);
    that.checkComplete = checkComplete.bind(that);
    that.onRun = onRun.bind(that);

    return that;
}

// ==================== createTrigger ====================

function createTrigger(that, name, type){
    console.log("[createTrigger] 创建Trigger", "name:", name, "type:", type);

    that = createCommonBase(that, name, type, baseType.trigger);

    createGetterSetter(that, "action", undefined, {}, that.dispatcher);
    createGetterSetter(that, "conditionOnTriggers", [], {}, that.dispatcher);
    createGetterSetter(that, "conditionOffTriggers", [], {}, that.dispatcher);
    createGetterSetter(that, "isConditionOk", false, {}, that.dispatcher);

    function dispatchConditionsOn(data){
        if(!this.isRunnable){
            this.logger.log("dispatchConditionsOn 不可运行");
            return;
        }
        this.logger.log("dispatchConditionsOn 分发事件");
        this.dispatcher.dispatchData(eventTypeTriggerConditionsOn, {target:this, data:data});
    }

    function dispatchConditionsOff(data){
        if(!this.isRunnable){
            this.logger.log("dispatchConditionsOff 不可运行");
            return;
        }
        this.logger.log("dispatchConditionsOff 分发事件");
        this.dispatcher.dispatchData(eventTypeTriggerConditionsOff, {target:this, data:data});
    }

    function onConditionsOn(event){
        this.logger.log("onConditionsOn");
        this.isConditionOk = true;
    }

    function onConditionsOff(event){
        this.logger.log("onConditionsOff");
        this.isConditionOk = false;
    }

    that.dispatchConditionsOn = dispatchConditionsOn.bind(that);
    that.dispatchConditionsOff = dispatchConditionsOff.bind(that);
    that.onConditionsOn = onConditionsOn.bind(that);
    that.onConditionsOff = onConditionsOff.bind(that);

    return that;
}

// ==================== createTriggerGroup ====================

function createTriggerGroup(that, name, type, isSequential){
    console.log("[createTriggerGroup] 创建TriggerGroup", "name:", name, "isSequential:", isSequential);

    that = createCommonBase(that, name, type, baseType.triggerGroup);

    attachAbstractAct(that);
    attachAbstractParent(that);

    // 存储每个trigger的触发状态
    var triggerConditionMap = {};

    createGetterSetter(that, "completeConditions", [], {}, that.dispatcher);

    function onRun(){
        this.logger.log("onRun 开始", "children数量:", this.children.length);

        // 如果没有children,直接触发成功
        if(this.children.length == 0){
            this.logger.log("onRun triggerGroup没有children,直接触发成功");
            this.dispatchSuccess();
            return;
        }

        // 初始化状态map
        for(var i = 0; i < this.children.length; i++){
            var trigger = this.children[i];
            triggerConditionMap[trigger.id] = false;
        }

        // 启动所有trigger
        for(var i = 0; i < this.children.length; i++){
            var trigger = this.children[i];

            this.logger.log("onRun 启动trigger", i, trigger.name);

            trigger.dispatcher.listenData(eventTypeTriggerConditionsOn, this.onTriggerConditionsOn);
            trigger.dispatcher.listenData(eventTypeTriggerConditionsOff, this.onTriggerConditionsOff);

            setChildProjectTaskAction(this, trigger);
            trigger.run(this);
        }
    }

    function onTriggerConditionsOn(event){
        this.logger.log("onTriggerConditionsOn 触发", event.target.name);

        triggerConditionMap[event.target.id] = true;

        this.checkTriggerGroupComplete();
    }

    function onTriggerConditionsOff(event){
        this.logger.log("onTriggerConditionsOff 触发", event.target.name);

        triggerConditionMap[event.target.id] = false;

        // ==================== 重置 isSuccess 状态 ====================
        // 当任一 trigger 的条件变为 false 时,重置 TriggerGroup 的 success 状态
        // 这样下次条件满足时可以重新触发 ActionGroup
        if(this.isSuccess){
            this.logger.log("onTriggerConditionsOff 重置 isSuccess 为 false");
            this.isSuccess = false;
        }
        // ==================== 重置完成 ====================
    }

    function checkTriggerGroupComplete(){
        this.logger.log("checkTriggerGroupComplete 检查");

        // 如果没有completeConditions,默认所有trigger都要触发
        if(this.completeConditions.length == 0){
            this.logger.log("checkTriggerGroupComplete 检查所有trigger");

            var allTriggered = true;
            for(var i = 0; i < this.children.length; i++){
                var trigger = this.children[i];
                if(!triggerConditionMap[trigger.id]){
                    this.logger.log("checkTriggerGroupComplete trigger未触发", i);
                    allTriggered = false;
                    break;
                }
            }

            if(allTriggered){
                this.logger.log("checkTriggerGroupComplete 所有trigger已触发");
                this.dispatchSuccess();
            }
            return;
        }

        // 检查completeConditions
        for(var i = 0; i < this.completeConditions.length; i++){
            var checkList = this.completeConditions[i];
            var checkMatched = true;

            this.logger.log("checkTriggerGroupComplete 检查条件", i);

            for(var j = 0; j < checkList.length; j++){
                var required = checkList[j];
                var trigger = this.children[j];

                if(required && !triggerConditionMap[trigger.id]){
                    this.logger.log("checkTriggerGroupComplete 必需trigger未触发", j);
                    checkMatched = false;
                    break;
                }
            }

            if(checkMatched){
                this.logger.log("checkTriggerGroupComplete 满足条件", i);
                this.dispatchSuccess();
                return;
            }
        }

        this.logger.log("checkTriggerGroupComplete 不满足任何条件");
    }

    var superOnExit = that.onExit;
    function onExit(){
        this.logger.log("onExit 退出所有triggers");
        callProjectMemberListExit(this.children);
        superOnExit.call(this);
    }

    that.onRun = onRun.bind(that);
    that.onTriggerConditionsOn = onTriggerConditionsOn.bind(that);
    that.onTriggerConditionsOff = onTriggerConditionsOff.bind(that);
    that.checkTriggerGroupComplete = checkTriggerGroupComplete.bind(that);
    that.onExit = onExit.bind(that);

    return that;
}

// ==================== createActionGroup ====================

function createActionGroup(that, name, type, isSequential){
    console.log("[createActionGroup] 创建ActionGroup", "name:", name, "isSequential:", isSequential);

    that = createCommonBase(that, name, type, baseType.actionGroup);

    if(isSequential){
        attachQueueGroup(that);
    }else{
        attachConcurrentGroup(that);
    }

    return that;
}

// ==================== createSingleAction ====================

function createSingleAction(that, name, type){
    console.log("[createSingleAction] 创建SingleAction", "name:", name);

    that = createCommonBase(that, name, type, baseType.action);

    attachAbstractAct(that);

    createGetterSetter(that, "conditionOnTriggers", [], {}, that.dispatcher);
    createGetterSetter(that, "conditionOffTriggers", [], {}, that.dispatcher);
    createGetterSetter(that, "onTriggerData", undefined, {}, that.dispatcher);

    // 新增：action 可执行状态（由 trigger on/off 控制）
    createGetterSetter(that, "isActionable", false, {}, that.dispatcher);
    // 新增：action 是否正在执行的标记
    createGetterSetter(that, "isActing", false, {}, that.dispatcher);

    var superRun = that.run;
    function run(parent){
        this.logger.log("run 开始");
        superRun.call(this, parent);  // 先调用父类 run（初始化状态）
        this.runTriggers();            // 再执行 runTriggers → doAction
    }

    function checkDoAction(data){
        if(!this.isRunnable){
            this.logger.log("checkDoAction 不可运行");
            return;
        }
        this.onTriggerData = data;
        this.doAction();
    }

    function doAction(data){
        this.logger.log("doAction 空实现");
        this.isActing = true;
    }

    function runTriggers(){
        this.logger.log("runTriggers", "conditionOnTriggers长度:", this.conditionOnTriggers.length);

        if(!this.conditionOnTriggers || this.conditionOnTriggers.length == 0){
            this.logger.log("runTriggers 无trigger,直接执行");
            // 无 trigger 时，默认设置为可执行
            this.isActionable = true;
            this.checkDoAction(undefined);
        }else{
            for(var i = 0; i < this.conditionOnTriggers.length; i++){
                var trigger = this.conditionOnTriggers[i];
                this.runTrigger(trigger, eventTypeTriggerConditionsOn, this.onConditionsOn);
            }
        }

        if(this.conditionOffTriggers){
            for(var i = 0; i < this.conditionOffTriggers.length; i++){
                var trigger = this.conditionOffTriggers[i];
                this.runTrigger(trigger, eventTypeTriggerConditionsOff, this.onConditionsOff);
            }
        }
    }

    function runTrigger(trigger, eventType, cb){
        this.logger.log("runTrigger", trigger.name, eventType);
        trigger.dispatcher.listenDomainData(eventType, this, cb);
        setChildProjectTaskAction(this, trigger);
        trigger.run(this);
    }

    function onConditionsOn(event){
        this.logger.log("onConditionsOn action 可以执行");
        this.isActionable = true;

        // 如果 action 还没开始执行，则启动
        if(!this.isActing){
            this.logger.log("onConditionsOn 启动 action");
            this.checkDoAction(event && event.data ? event.data : event);
        } else {
            // 如果已经在执行，通知 action 恢复
            this.logger.log("onConditionsOn 恢复 action");
            this.onActionResume(event && event.data ? event.data : event);
        }
    }

    function onConditionsOff(event){
        this.logger.log("onConditionsOff action 不可执行");
        this.isActionable = false;

        // 通知 action 暂停
        if(this.isActing){
            this.logger.log("onConditionsOff 暂停 action");
            this.onActionPause(event && event.data ? event.data : event);
        }
    }

    function onActionPause(data){
        this.logger.log("onActionPause action 暂停（空实现，由具体 action 重写）");
        // 由具体 action 实现暂停逻辑
    }

    function onActionResume(data){
        this.logger.log("onActionResume action 恢复（空实现，由具体 action 重写）");
        // 由具体 action 实现恢复逻辑
    }

    function onExit(){
        this.logger.log("onExit");
        this.exitTriggers();
    }

    function exitTriggers(){
        this.logger.log("exitTriggers");
        callProjectMemberListExit(this.conditionOnTriggers);
        callProjectMemberListExit(this.conditionOffTriggers);
    }

    that.run = run.bind(that);
    that.checkDoAction = checkDoAction.bind(that);
    that.doAction = doAction.bind(that);
    that.runTriggers = runTriggers.bind(that);
    that.runTrigger = runTrigger.bind(that);
    that.onExit = onExit.bind(that);
    that.exitTriggers = exitTriggers.bind(that);
    that.onConditionsOn = onConditionsOn.bind(that);
    that.onConditionsOff = onConditionsOff.bind(that);
    that.onActionPause = onActionPause.bind(that);
    that.onActionResume = onActionResume.bind(that);

    return that;
}

// ==================== createTriggerAction ====================

function createTriggerAction(that, name, type){
    console.log("[createTriggerAction] 创建TriggerAction", "name:", name);

    that = createCommonBase(that, name, type, baseType.triggerAction);

    attachAbstractAct(that);

    createGetterSetter(that, "triggerGroup", undefined, {}, that.dispatcher);
    createGetterSetter(that, "actionGroup", undefined, {}, that.dispatcher);

    function onRun(){
        this.logger.log("onRun 开始");
        this.runTriggerGroup();
    }

    function runTriggerGroup(){
        var triggerGroup = this.triggerGroup;

        if(!triggerGroup){
            this.logger.log("runTriggerGroup triggerGroup不存在");
            this.dispatchFailed({error: "triggerGroup not found"});
            return;
        }

        this.logger.log("runTriggerGroup 监听事件");

        triggerGroup.dispatcher.listenData(eventTypeSuccess, this.onTriggerGroupSuccess);
        triggerGroup.dispatcher.listenData(eventTypeFailed, this.onTriggerGroupFailed);

        setChildProjectTaskAction(this, triggerGroup);

        this.logger.log("runTriggerGroup 运行");
        triggerGroup.run(this);
    }

    function onTriggerGroupSuccess(event){
        this.logger.log("onTriggerGroupSuccess TriggerGroup成功");
        this.runActionGroup();
    }

    function onTriggerGroupFailed(event){
        this.logger.log("onTriggerGroupFailed TriggerGroup失败");
        this.dispatchFailed(event.data);
    }

    function runActionGroup(){
        var actionGroup = this.actionGroup;

        if(!actionGroup){
            this.logger.log("runActionGroup actionGroup不存在");
            this.dispatchFailed({error: "actionGroup not found"});
            return;
        }

        this.logger.log("runActionGroup 监听事件");

        actionGroup.dispatcher.listenData(eventTypeSuccess, this.onActionGroupSuccess);
        actionGroup.dispatcher.listenData(eventTypeFailed, this.onActionGroupFailed);

        setChildProjectTaskAction(this, actionGroup);

        this.logger.log("runActionGroup 运行");
        actionGroup.run(this);
    }

    function onActionGroupSuccess(event){
        this.logger.log("onActionGroupSuccess ActionGroup成功");
        this.dispatchSuccess();
    }

    function onActionGroupFailed(event){
        this.logger.log("onActionGroupFailed ActionGroup失败");
        this.dispatchFailed(event.data);
    }

    var superOnExit = that.onExit;
    function onExit(){
        this.logger.log("onExit");
        if(this.triggerGroup){
            this.triggerGroup.exit();
        }
        if(this.actionGroup){
            this.actionGroup.exit();
        }
        superOnExit.call(this);
    }

    that.onRun = onRun.bind(that);
    that.runTriggerGroup = runTriggerGroup.bind(that);
    that.onTriggerGroupSuccess = onTriggerGroupSuccess.bind(that);
    that.onTriggerGroupFailed = onTriggerGroupFailed.bind(that);
    that.runActionGroup = runActionGroup.bind(that);
    that.onActionGroupSuccess = onActionGroupSuccess.bind(that);
    that.onActionGroupFailed = onActionGroupFailed.bind(that);
    that.onExit = onExit.bind(that);

    return that;
}

// ==================== createTriggerActionGroup ====================

function createTriggerActionGroup(that, name, type, isSequential){
    console.log("[createTriggerActionGroup] 创建TriggerActionGroup", "name:", name, "isSequential:", isSequential);

    that = createCommonBase(that, name, type, baseType.triggerActionGroup);

    if(isSequential){
        attachQueueGroup(that);
    }else{
        attachConcurrentGroup(that);
    }

    return that;
}

// ==================== createProject ====================

function createProject(that, name, type){
    console.log("[createProject] 创建Project", "name:", name);

    that = createCommonBase(that, name, type, baseType.project);

    attachQueueGroup(that);

    function terminate(){
        this.logger.log("terminate 中止Project");
        this.isTerminated = true;
        this.exit();
    }

    that.terminate = terminate.bind(that);

    return that;
}

// ==================== Build 函数 ====================

function buildTrigger(triggerData, triggerGroup){
    console.log("[buildTrigger] 构建Trigger", triggerData.id);

    var trigger = createTrigger({}, triggerData.name, triggerData.type);

    trigger.id = triggerData.id;
    console.log("[buildTrigger] 设置 trigger.data = triggerData.javaData");
    trigger.data = triggerData.javaData;
    trigger.buildData = triggerData;
    console.log("[buildTrigger] trigger.data:", trigger.data);
    console.log("[buildTrigger] trigger.buildData.id:", trigger.buildData.id);
    trigger.project = triggerGroup.project;
    trigger.owner = triggerGroup;

    // ==================== 传递 triggerActionContext ====================
    console.log("[buildTrigger] 传递 triggerActionContext");
    trigger.triggerActionContext = triggerGroup.triggerActionContext;
    console.log("[buildTrigger] triggerActionContext 已传递");
    // ==================== triggerActionContext 传递完成 ====================

    if(triggerData.type){
        var triggerStore = javaLib["fanfanlo/javajs/v1/project/store"].getTrigger(triggerData.type);
        if(triggerStore){
            console.log("[buildTrigger] triggerStore 存在:", triggerData.type);
            if(triggerStore.attach){
                console.log("[buildTrigger] 调用attach", triggerData.type);
                triggerStore.attach(trigger);
            }else{
                console.log("[buildTrigger] 警告: triggerStore.attach 不存在", triggerData.type);
            }
        }else{
            console.log("[buildTrigger] 警告: 未找到 triggerStore", triggerData.type);
        }
    }else{
        console.log("[buildTrigger] 警告: triggerData.type 为空");
    }

    return trigger;
}

function buildTriggerGroup(triggerGroupData, triggerAction){
    console.log("[buildTriggerGroup] 构建TriggerGroup", triggerGroupData.id);

    var isSequential = triggerGroupData.isSequential !== undefined ? triggerGroupData.isSequential : true;

    var triggerGroup = createTriggerGroup(
        {},
        triggerGroupData.name,
        triggerGroupData.type,
        isSequential
    );

    triggerGroup.id = triggerGroupData.id;
    triggerGroup.data = triggerGroupData;
    triggerGroup.project = triggerAction.project;
    triggerGroup.owner = triggerAction;

    // ==================== 传递 triggerActionContext ====================
    console.log("[buildTriggerGroup] 传递 triggerActionContext");
    triggerGroup.triggerActionContext = triggerAction.triggerActionContext;
    console.log("[buildTriggerGroup] triggerActionContext 已传递");
    // ==================== triggerActionContext 传递完成 ====================

    var triggerList = triggerGroupData.children || [];
    console.log("[buildTriggerGroup] 构建Triggers", "数量:", triggerList.length);

    for(var i = 0; i < triggerList.length; i++){
        var triggerData = triggerList[i];
        var triggerThat = buildTrigger(triggerData, triggerGroup);
        triggerGroup.children.push(triggerThat);
    }

    if(triggerGroupData.checks){
        console.log("[buildTriggerGroup] 设置checks");
        triggerGroup.completeConditions = triggerGroupData.checks;
    }

    return triggerGroup;
}

function buildAction(actionData, actionGroup){
    console.log("[buildAction] 构建Action", actionData.id);

    var action = createSingleAction({}, actionData.name, actionData.type);

    action.id = actionData.id;
    console.log("[buildAction] 设置 action.data = actionData.javaData");
    action.data = actionData.javaData;
    action.buildData = actionData;
    console.log("[buildAction] action.data:", action.data);
    console.log("[buildAction] action.buildData.id:", action.buildData.id);
    action.project = actionGroup.project;
    action.owner = actionGroup;

    // ==================== 传递 triggerActionContext ====================
    console.log("[buildAction] 传递 triggerActionContext");
    action.triggerActionContext = actionGroup.triggerActionContext;
    console.log("[buildAction] triggerActionContext 已传递");
    // ==================== triggerActionContext 传递完成 ====================

    if(actionData.type){
        var actionStore = javaLib["fanfanlo/javajs/v1/project/store"].getAction(actionData.type);
        if(actionStore){
            console.log("[buildAction] actionStore 存在:", actionData.type);
            if(actionStore.attach){
                console.log("[buildAction] 调用attach", actionData.type);
                actionStore.attach(action);
            }else{
                console.log("[buildAction] 警告: actionStore.attach 不存在", actionData.type);
            }
        }else{
            console.log("[buildAction] 警告: 未找到 actionStore", actionData.type);
        }
    }else{
        console.log("[buildAction] 警告: actionData.type 为空");
    }

    return action;
}

function buildActionGroup(actionGroupData, triggerAction){
    console.log("[buildActionGroup] 构建ActionGroup", actionGroupData.id);

    var isSequential = actionGroupData.isSequential !== undefined ? actionGroupData.isSequential : true;

    var actionGroup = createActionGroup(
        {},
        actionGroupData.name,
        actionGroupData.type,
        isSequential
    );

    actionGroup.id = actionGroupData.id;
    actionGroup.data = actionGroupData;
    actionGroup.project = triggerAction.project;
    actionGroup.owner = triggerAction;

    // ==================== 传递 triggerActionContext ====================
    console.log("[buildActionGroup] 传递 triggerActionContext");
    actionGroup.triggerActionContext = triggerAction.triggerActionContext;
    console.log("[buildActionGroup] triggerActionContext 已传递");
    // ==================== triggerActionContext 传递完成 ====================

    var actionList = actionGroupData.children || [];
    console.log("[buildActionGroup] 构建Actions", "数量:", actionList.length);

    for(var i = 0; i < actionList.length; i++){
        var actionData = actionList[i];
        var actionThat = buildAction(actionData, actionGroup);
        actionGroup.children.push(actionThat);
    }

    if(actionGroupData.checks){
        console.log("[buildActionGroup] 设置checks");
        actionGroup.completeConditions = actionGroupData.checks;
    }

    return actionGroup;
}

function buildTriggerAction(triggerActionData, triggerActionGroup){
    console.log("[buildTriggerAction] 构建TriggerAction", triggerActionData.id);

    var triggerAction = createTriggerAction(
        {},
        triggerActionData.name,
        triggerActionData.type
    );

    triggerAction.id = triggerActionData.id;
    triggerAction.data = triggerActionData;
    triggerAction.project = triggerActionGroup.project;
    triggerAction.owner = triggerActionGroup;

    // ==================== 创建 triggerActionContext ====================
    console.log("[buildTriggerAction] 创建 triggerActionContext");
    var triggerActionContext = {};
    triggerAction.triggerActionContext = triggerActionContext;
    console.log("[buildTriggerAction] triggerActionContext 已创建");
    // ==================== triggerActionContext 创建完成 ====================

    console.log("[buildTriggerAction] 构建TriggerGroup");
    var triggerGroupThat = buildTriggerGroup(triggerActionData.triggerGroup, triggerAction);
    triggerAction.triggerGroup = triggerGroupThat;

    console.log("[buildTriggerAction] 构建ActionGroup");
    var actionGroupThat = buildActionGroup(triggerActionData.actionGroup, triggerAction);
    triggerAction.actionGroup = actionGroupThat;

    return triggerAction;
}

function buildTriggerActionGroup(triggerActionGroupData, project){
    console.log("[buildTriggerActionGroup] 构建TriggerActionGroup", triggerActionGroupData.id);

    var isSequential = triggerActionGroupData.isSequential !== undefined ? triggerActionGroupData.isSequential : true;

    var triggerActionGroup = createTriggerActionGroup(
        {},
        triggerActionGroupData.name,
        triggerActionGroupData.type,
        isSequential
    );

    triggerActionGroup.id = triggerActionGroupData.id;
    triggerActionGroup.data = triggerActionGroupData;
    triggerActionGroup.project = project;

    var triggerActionList = triggerActionGroupData.children || [];
    console.log("[buildTriggerActionGroup] 构建TriggerActions", "数量:", triggerActionList.length);

    for(var i = 0; i < triggerActionList.length; i++){
        var triggerActionData = triggerActionList[i];
        var triggerActionThat = buildTriggerAction(triggerActionData, triggerActionGroup);
        triggerActionGroup.children.push(triggerActionThat);
    }

    if(triggerActionGroupData.checks){
        console.log("[buildTriggerActionGroup] 设置checks");
        triggerActionGroup.completeConditions = triggerActionGroupData.checks;
    }

    return triggerActionGroup;
}

function buildProject(projectData){
    console.log("[buildProject] ========== 开始构建Project ==========", projectData.client_id);

    var project = createProject({}, projectData.name, projectData.type);

    project.data = projectData;

    console.log("[buildProject] 构建TriggerActionGroup");
    var triggerActionGroupThat = buildTriggerActionGroup(projectData.triggerActionGroup, project);

    project.children = [triggerActionGroupThat];

    console.log("[buildProject] Project构建完成");
    return project;
}

// ==================== projectBuilder ====================

function projectBuilder(initData){
    try{
        console.log("[projectBuilder] ========== 开始 ==========");

        // 修复: 兼容两种传入方式
        projectInitData = initData.projectInitData || initData;
        console.log("[projectBuilder] projectInitData:", projectInitData.client_id, projectInitData.name);

        var project = buildProject(projectInitData);

        function onScriptCallExit(){
            console.log("[projectBuilder] 脚本退出回调");
            if(project.isTerminated || project.isExited || project.isSuccess || project.isFailed){
                console.log("[projectBuilder] Project已结束,跳过");
                return;
            }
            project.isTerminated = true;
            project.exit();
            project.dispatchComplete();
        }

        addScriptExitListener(onScriptCallExit);

        // ==================== keepAlive 控制逻辑 ====================
        const keepAlive = projectInitData.keepAlive;
        console.log("[projectBuilder] keepAlive:", String(keepAlive));
        console.log("[projectBuilder] keepAlive type:", typeof keepAlive);

        const shouldKeepAlive = keepAlive === true;
        console.log("[projectBuilder] shouldKeepAlive:", shouldKeepAlive);
        // ==================== keepAlive 控制逻辑结束 ====================

        // 只有在非 keepAlive 模式下才监听 Complete/Failed 事件自动退出
        if (!shouldKeepAlive) {
            console.log("[projectBuilder] 非 keepAlive 模式,监听 Complete/Failed 事件");

            project.dispatcher.listenData(eventTypeComplete, function(event){
                console.log("[projectBuilder] ========== Project完成 ==========");
                console.log("[projectBuilder] keepAlive:", shouldKeepAlive, "调用 project.exit()");
                project.exit();
            });

            project.dispatcher.listenData(eventTypeFailed, function(event){
                console.log("[projectBuilder] ========== Project失败 ==========");
                console.log("[projectBuilder] keepAlive:", shouldKeepAlive, "调用 project.exit()");
                project.exit();
            });
        } else {
            console.log("[projectBuilder] keepAlive 模式,不监听 Complete/Failed 事件");
            console.log("[projectBuilder] Project 将持续运行,直到手动终止或脚本退出");
        }

        // Exit 事件监听器始终存在,用于清理资源
        project.dispatcher.listenData(eventTypeExit, function(event){
            console.log("[projectBuilder] ========== Project退出 ==========");
            console.log("[projectBuilder] 调用 jsCallComplete()");
            jsCallComplete();
        });

        console.log("[projectBuilder] 运行Project");
        project.run();

    }catch(e){
        console.log("[projectBuilder] 错误", e.message, e.stack);
    }
}

// ==================== 导出 ====================`;
